// extracted by mini-css-extract-plugin
export default {"button":"loading_button__9ULDx","spinner":"loading_spinner__DU2Xm","spin":"loading_spin__Rx3TK"};